<template>
  <v-container fluid class="pa-0 ma-0">
   <div id="top"></div>
    
   
    <!-- <router-link to="#page-top">
        <v-btn fab dark fixed right bottom small color="indigo" class=" top-buttan">
            <v-icon dark >keyboard_arrow_up</v-icon>
        </v-btn>
    </router-link>  -->
    
    <!-- <div id="page-top"></div> -->
    <v-layout row wrap    >
      <v-flex v-for="award in awards" :key="award.id"  v-if="id == award.type"> 
          <!-- <a v-bind:href="'#' + award.type"> -->
              <div class="page-title pt-3">AWARDS <span class="title-bar">|</span class="page-category"> {{award.title}}</div>
          <!-- </a> -->
      </v-flex>
    </v-layout>

     <v-layout>
          <v-flex xs12 class="text-xs-center">
            <v-progress-circular
              indeterminate
              class="primary--text"
              :width="7"
              :size="70"
              v-if="loading"></v-progress-circular>
          </v-flex>
      </v-layout>
    
      
        <!-- <a id="best-top"></a> -->
       
        <v-layout row wrap   class="content-inner" >
          <v-flex xs12 sm12 md12 lg12 xl12  >
            <div id="vue-carousel" class="vue-carousel">


              <transition :name="transition_name" v-if="!loading">


                <!-- <div class="vue-carousel_body" 
                  :key="index"
                  v-for="(meetup, index) in meetups"
                  v-if="visible_content == index"
                  > -->
                   <!-- <div class="vue-carousel_body" 
                  :key="index"
                  v-for="(meetup, index) in  meetupsFilters"
                  v-if="visible_content == index"
                  > -->
                   <div class="vue-carousel_body" 
                  :key="index"
                  v-for="(meetup, index) in  meetupsFiltersType"
                  v-if="visible_content == index"
                  >
                 
                    <v-layout row wrap   > 
                      <v-flex xs12 sm12 md12 lg9 xl9  class="car-img">
                          <img :src="meetup.imageUrl"  :alt="meetup.title" class="carousel-img"  @click="onLoadMeetupEntry(meetup.id)">
                      </v-flex>
                       <v-flex xs12 sm12 md12 lg3 xl3  class="car-text">
                         <div class="car-text-grp">
                          <h5>{{meetup.title}}</h5>
                          <p>{{meetup.category}} &nbsp;  {{meetup.date |  date}}</p>
                          <!-- <p>{{meetup.id}} </p> -->
                          <p v-show="dspCaption">{{meetup.description.slice(0,80)}}...</p>
                          <div class="vue-carousel_footer">
                            <button @click="back()" :disabled="visible_content == 0"><v-icon coclor="lightgray">chevron_left</v-icon>PREV</button>
                            <p>{{ index + 1}} / {{meetupsFiltersType.length }}</P>
                            <button @click="next()" :disabled="visible_content == meetupsFiltersType.length - 1">NEXT<v-icon coclor="lightgray">chevron_right</v-icon></button>
                          </div>
                          <div class="vue-carousel_footer">
                            <v-btn fab small @click="onLoadMeetupThumnail(meetup.type)"><v-icon>border_all</v-icon></v-btn>
                            <v-btn fab small  @click="onLoadMeetupEntry(meetup.id)"><v-icon>expand_more</v-icon></v-btn>
                            <!-- <v-btn fab small  @click="dspCaption = true"><v-icon>insert_comment</v-icon></v-btn> -->
                            <v-btn fab small  @click="dspCaptionSw()"><v-icon>insert_comment</v-icon></v-btn>
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>

                    <!-- <img :src="meetup.imageUrl"  alt="meetup.title" class="carousel-img"  @click="onLoadMeetupPost(meetup.id)">
                    <div class="carousel-item-text">
                        <p>{{meetup.title}}</p>
                        <p>{{meetup.category}} {{meetup.date |  date}}</p>
                        
                    </div> -->

                </div>

              </transition>

              <!-- <div class="vue-carousel_footer">
                <button @click="back()" :disabled="visible_content == 0"><v-icon>chevron_left</v-icon></button>
                <div class="vue-carousel_footer_dot"
                  v-for="(contents, index) in contents"
                  :class="{'is-visible' : visible_content == index}"></div>
                <button @click="next()" :disabled="visible_content == meetups.length - 1"><v-icon>chevron_right</v-icon></button>
              </div> -->
            </div> 
          </v-flex>
        </v-layout>
       

       
     <v-flex  xs12 lg8 xl8 style="text-align: left;" class="ma-4">
         <v-btn  @click="onBack">
                Back
                  <span slot="loader" class="custom-loader">
                  <v-icon>cached</v-icon>
                  </span>
              </v-btn>

              
      </v-flex>
    </v-layout>

    
  </v-container>
</template>

<script>
export default {
 props: ['id'],
 name: 'carrousel',
     data () {
      return {
        dspCaption: false,
        awards: [
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0208b1x1.jpg',
            id:1, 
            title:'BEST TITLE', 
            titleJp:'タイトル部門', 
            subTitle:'Select the best title image from all the stages', 
            subTitleJp:'２０１７年に投稿した１１ステージのタイトル画像から最も気に入っているデザインを選びました。', 
            type:'awStage'
            },
            {imageUrl: ' http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0259.jpg',
            id:2, 
            title:'BEST STAGE', 
            titleJp:'ベストステージ部門', 
            subTitle:'Select the best post image from all the stages', 
            subTitleJp:'各ステージの中から一番のお気に入りを選びました。', 
            type:'awPost'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2931.jpg',
            id:3, 
            title:'BEST DAYTIME', 
            titleJp:'デイタイム部門', 
            subTitle:'Select the best Daytime image from all the stages', 
            subTitleJp:'昼間のシーンからお気に入りを選びました。', 
            type:'awDaytime'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/b_road_panorama1b.jpg',
            id:4, 
            title:'BEST TWILIGHT', 
            titleJp:'トワイライト部門', 
            subTitle:'Select the best twilight image from all the stages', 
            subTitleJp:'夕暮れのシーンからお気に入りを選びました。', 
            type:'awTwilite'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img9665.jpg',
            id:5, 
            title:'BEST NIGHT', 
            titleJp:'ナイト部門', 
            subTitle:'Select the best night image from all the stages', 
            subTitleJp:'夜景の中からお気に入りを選びました。', 
            type:'awNight'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',
            id:6, 
            title:'BEST VEHICLE', 
            titleJp:'ビークル部門', 
            subTitle:'Select the best vehicle image from all the stages', 
            subTitleJp:'車、船など乗り物の画像から一番のお気に入りを選びました。', 
            type:'awVehicle'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/img1875base.jpg',
            id:7, 
            title:'BEST COMPOSIT', 
            titleJp:'合成部門', 
            subTitle:'Select the best composit image from all the stages', 
            subTitleJp:'３Dモデルの画像合成、アニメーション画像から一番のお気に入りを選びました。', 
            type:'awComposit'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img0749a1x1.jpg',
            id:8, 
            title:'BEST HDR', 
            titleJp:'ＨＤＲ部門', 
            subTitle:'Select the best HDR image from all the stages', 
            subTitleJp:'すべてのＨＤＲ画像から一番のお気に入りを選びました。', 
            type:'awHdr'
            }
        ],
        contents: [{
        title: 'Content 1',
        bg_color: '#7bbff9',
      },{
        title: 'Content 2',
        bg_color: '#f16972',
      },{
        title: 'Content 3',
        bg_color: '#20d2a3',
      }],
        transition_name: 'show-next',
        visible_content: 0,
      }
    },

 methods: {
    onBack () {
      this.$router.push('/top' )
    },
    onLoadMeetupPost (id) {
      this.$router.push('/post/' + id)
    },
    onLoadMeetupThumnail (id) {
      this.$router.push('/thumnail/' + id)
    },
    onLoadMeetupEntry (id) {
      this.$router.push('/entry/' + id)
    },
    back(){
      this.transition_name = 'show-prev';
      this.visible_content--;
    },
    next(){
      this.transition_name = 'show-next';
      this.visible_content++;
    },
    dspCaptionSw(){
      this.dspCaption = !this.dspCaption
    }
    
  },
 computed: {
     meetups () {
        return this.$store.getters.featuredMeetups
      },
      // meetupsFilters () {
      //   console.log('meetupsFilters')
      //   return this.$store.getters.featuredMeetupsFilters
      // },
      meetupsFiltersType () {
        // console.log('meetupsFiltersType')
        return this.$store.getters.featuredMeetupsFiltersType(this.id)
      },
    //   meetup () {
    //     return this.$store.getters.loadedMeetup(this.id)
    //   },
    //   userIsAuthenticated () {
    //     return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    //   },
    //   userIsCreator () {
    //     if (!this.userIsAuthenticated) {
    //       return false
    //     }
    //     return this.$store.getters.user.id === this.meetup.creatorId
    //   },
      loading () {
        return this.$store.getters.loading
      },
      isCaption(){
       this.isCaption = !this.isCaption
      }
     
     

    }

 
}
</script>

<style scoped>
/* *{
    border:dotted 1px gray
} */


.best-title-inner h4 {
     border-bottom: solid 1px red;
      padding: 0  0 0 .5rem;
}
.best-description-inner {
    padding: 0 4rem;
}
.best-description-inner h6{
     line-height: 2.4rem;
     letter-spacing: .2rem;
    
}
.page-title {
    font-size: 1em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
  .title-bar{
    color:red;
    font-weight: 400;
    font-size: 1.6em;
    vertical-align: -1px;
  }
  .page-category{
    font-size: 1em;
    font-weight: 300;
  }
.top-buttan{
  z-index: 100;
}


.vue-carousel{
  height: 360px;
  overflow: hidden;
  position: relative;
  width:360px;
  margin:0 auto;
 
  
}
  .vue-carousel_body{
    color: #fff;
    /* height: 150px; */
    /* left: 0; */
    /* line-height: 150px; */
    /* position: absolute; */
    /* text-align: center; */
    /* top: 0; */
    width: 100%; 
    height:100%;
    /* padding: 0 50px;  */
    display: flex;
    justify-content: center;
    align-items: center;
  }
.carousel-img{
  width:auto;
  height:auto;
  max-width:100%;
  max-height:100%;
}
.car-img{
    width:360px;
    height:360px;
    display: flex;
    justify-content: center;
    align-items:     center;
   
  }
.car-text{
    padding:16px;
  }
.car-text-grp{
  /* width: 280px; */
  width: 100%;
  /* position: absolute; */
  border: solid 1px white;
 
  /* -webkit-transform: translateY(-50%) ;
  transform: translateY(-50%) ; */
  padding: 16px  ;
  text-align: center;
}

  .vue-carousel_footer{
    align-items: center;
    display: flex;
    height: 50px;
    justify-content: space-between;
    /* position: absolute; */
    position: relative;
    top: 0px;
    width: 100%;
    color:lightgray;
  }
  /* .vue-carousel_footer_dot{
    	background-color: #abc2ce;
			border-radius: 50%;
			height: 6px;
      width: 6px;
  }
      
  .vue-carouse_footer_dot .is-visible{
    background-color: #7b94f9;
  } */
 

.show-next-enter-active, .show-next-leave-active,
.show-prev-enter-active, .show-prev-leave-active  {
  transition: all .4s;
}
.show-next-enter, .show-prev-leave-to {
  transform: translateX(100%);
}
.show-next-leave-to, .show-prev-enter {
  transform: translateX(-100%);
}



.best-inner {
     padding: 1rem 2rem 1rem 2em;
}
.best-inner img{
    border: solid 1px white;
}

/* xs */
@media only screen and (max-width: 600px){
   .vue-carousel{
    width:320px;
    height:800px;
  }
   .car-img{
    width:320px;
    height:320px;
  }
  .carousel-item-text{
  bottom: 0;
  right: 0;
  width:360px;
  padding: 0px ;
  margin-top:80px;
  border: solid 1px red;
  }
  .car-text-grp{
    width: 100%;
    border: solid 1px white;
    padding: 16px  ;
    text-align: center;
  }

  .page-title {
    font-size: 1em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
  .title-bar{
    color:red;
    font-weight: 400;
    font-size: 1.6em;
    vertical-align: -1px;
  }
  .page-category{
    font-size: 1em;
    font-weight: 300;
  }
  
}
/* sm */
@media only screen and (min-width: 599px) and (max-width: 959px){
   .vue-carousel{
    width:428px;
    height:1000px;
  }
  .car-img{
    width:400px !important;
    height:400px !important;
  }
  .carousel-item-text{
    position: absolute;
    bottom: 0;
    right: 50%;
    -webkit-transform: translatex(-50%) ;
    transform: translatex(-50%) ;
    width:360px;
    padding: 0px  0px;
    border: solid 1px white;
  }
.car-text-grp{
    width: 100%;
    border: solid 1px white;
    padding: 16px  ;
    text-align: center;
  }
  .page-title {
    font-size: 2em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
.title-bar{
  color:red;
   font-weight: 100;
   font-size: 1.6em;
  vertical-align: -5px;
}
.page-category{
  font-size: 2em;
  font-weight: 300;

}
  
}
/* ms */
@media only screen and (min-width: 960px) and (max-width: 1264px){
   .vue-carousel{
    width:768px;
    height:1024px;
    
  }
   .car-img{
    width:560px;
    height:560px;
  }
  .carousel-item-text{
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%) ;
  transform: translateY(-50%) ;
  width:360px;
  padding: 0;
  border: solid 1px pink;
}
.page-title {
    font-size: 2em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
.title-bar{
  color:red;
   font-weight: 100;
   font-size: 1.6em;
  vertical-align: -5px;
}
.page-category{
  font-size: 2em;
  font-weight: 300;

}
  
}
/* lg */
@media only screen and (min-width: 1265px) and (max-width: 1904px){
   .vue-carousel{
    width:1265px;
    height:800px;
  } 
  .car-img{
    width:800px;
    height:800px;
  }
  .carousel-item-text{
    position: absolute;
    top: 50%;
    right: 0;
    -webkit-transform: translateY(-50%) ;
    transform: translateY(-50%) ;
    width:360px;
    padding: 50px  50px;
    border: solid 1px white;
  }
  .car-text-grp{
    width: 280px;
    position: absolute;
    border: solid 1px white;
    top: 50%;
    -webkit-transform: translateY(-50%) ;
    transform: translateY(-50%) ;
    padding: 16px  ;
  }
  .page-title {
    font-size: 2em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
.title-bar{
  color:red;
   font-weight: 100;
   font-size: 1.6em;
  vertical-align: -5px;
}
.page-category{
  font-size: 2em;
  font-weight: 300;

}
}
/* xl */
@media only screen and (min-width: 1905px) {
  .vue-carousel{
    width:1905px;
    height:1000px;
  }
  .car-img{
    width:1000px;
    height:1000px;
  }
  .carousel-img{
    width:auto;
    height:auto;
    max-width:100%;
    max-height:100%;
    
  }
  .carousel-item-text{
    position: absolute;
    top: 50%;
    right: 0;
    -webkit-transform: translateY(-50%) ;
    transform: translateY(-50%) ;
    width:360px;
    padding: 50px  50px;
    border: solid 1px white;
  }
  .car-text-grp{
    width: 280px;
    position: absolute;
    border: solid 1px white;
    top: 50%;
    -webkit-transform: translateY(-50%) ;
    transform: translateY(-50%) ;
    padding: 16px  ;
  }
  .page-title {
    font-size: 2em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
.title-bar{
  color:red;
   font-weight: 100;
   font-size: 1.6em;
  vertical-align: -5px;
}
.page-category{
  font-size: 2em;
  font-weight: 300;

}
}


</style>



// WEBPACK FOOTER //
// src/components/awards/awardsBest.vue